import { useEffect } from "react";

/**
 * Small SEO helper that sets document title and meta description per page.
 * Keeps things simple without a full react-helmet dependency.
 */
export default function Seo({ title, description, path }) {
    useEffect(() => {
        if (title) document.title = title;

        const ensureMeta = (selector, attr, value) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                const [key, val] = selector.replace(/meta\[|\]/g, "").split("=");
                el.setAttribute(key, val.replace(/"/g, ""));
                document.head.appendChild(el);
            }
            if (value != null) el.setAttribute(attr, value);
        };

        if (description) {
            ensureMeta('meta[name="description"]', "content", description);
            ensureMeta('meta[property="og:description"]', "content", description);
            ensureMeta('meta[name="twitter:description"]', "content", description);
        }
        if (title) {
            ensureMeta('meta[property="og:title"]', "content", title);
            ensureMeta('meta[name="twitter:title"]', "content", title);
        }
        if (path) {
            ensureMeta('meta[property="og:url"]', "content", `https://chiefai.partners${path}`);
        }
    }, [title, description, path]);

    return null;
}
